module.exports = __webpack_public_path__ + "img/img-2.0e256531.svg";